/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CaseTypeDto
 */
export interface CaseTypeDto {
    /**
     * 
     * @type {boolean}
     * @memberof CaseTypeDto
     */
    active?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CaseTypeDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseTypeDto
     */
    typeCode?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseTypeDto
     */
    displayName?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseTypeDto
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseTypeDto
     */
    category?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseTypeDto
     */
    categoryDisplayName?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseTypeDto
     */
    defaultSeverity?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof CaseTypeDto
     */
    workflowConfig?: { [key: string]: any; };
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof CaseTypeDto
     */
    requiredFields?: { [key: string]: any; };
    /**
     * 
     * @type {boolean}
     * @memberof CaseTypeDto
     */
    isActive?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof CaseTypeDto
     */
    created?: Date;
    /**
     * 
     * @type {Date}
     * @memberof CaseTypeDto
     */
    updated?: Date;
}

/**
 * Check if a given object implements the CaseTypeDto interface.
 */
export function instanceOfCaseTypeDto(value: object): value is CaseTypeDto {
    return true;
}

export function CaseTypeDtoFromJSON(json: any): CaseTypeDto {
    return CaseTypeDtoFromJSONTyped(json, false);
}

export function CaseTypeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CaseTypeDto {
    if (json == null) {
        return json;
    }
    return {
        
        'active': json['active'] == null ? undefined : json['active'],
        'id': json['id'] == null ? undefined : json['id'],
        'typeCode': json['typeCode'] == null ? undefined : json['typeCode'],
        'displayName': json['displayName'] == null ? undefined : json['displayName'],
        'description': json['description'] == null ? undefined : json['description'],
        'category': json['category'] == null ? undefined : json['category'],
        'categoryDisplayName': json['categoryDisplayName'] == null ? undefined : json['categoryDisplayName'],
        'defaultSeverity': json['defaultSeverity'] == null ? undefined : json['defaultSeverity'],
        'workflowConfig': json['workflowConfig'] == null ? undefined : json['workflowConfig'],
        'requiredFields': json['requiredFields'] == null ? undefined : json['requiredFields'],
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
        'created': json['created'] == null ? undefined : (new Date(json['created'])),
        'updated': json['updated'] == null ? undefined : (new Date(json['updated'])),
    };
}

export function CaseTypeDtoToJSON(json: any): CaseTypeDto {
    return CaseTypeDtoToJSONTyped(json, false);
}

export function CaseTypeDtoToJSONTyped(value?: CaseTypeDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'active': value['active'],
        'id': value['id'],
        'typeCode': value['typeCode'],
        'displayName': value['displayName'],
        'description': value['description'],
        'category': value['category'],
        'categoryDisplayName': value['categoryDisplayName'],
        'defaultSeverity': value['defaultSeverity'],
        'workflowConfig': value['workflowConfig'],
        'requiredFields': value['requiredFields'],
        'isActive': value['isActive'],
        'created': value['created'] == null ? undefined : ((value['created']).toISOString()),
        'updated': value['updated'] == null ? undefined : ((value['updated']).toISOString()),
    };
}

